declare const SlotCom: unknown;

export function isLegacyPortal(): boolean {
  return typeof SlotCom === 'object';
}
